import {
  AbTestDocument,
  withStandardPrefetchHook,
} from '@spotify/confidence-graphql';

export const useAbTestPrefetch = withStandardPrefetchHook(AbTestDocument);
